import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import Modal, { ModalHeader } from '../../utils/Modal';
import styles from './PointerInputHelpModal.module.css';

export const isMac =
  typeof window !== 'undefined' && window.navigator.platform.includes('Mac');

interface PointerInputHelpModalProps {
  onClose: () => void;
}

const PointerInputHelpModal: React.FC<PointerInputHelpModalProps> = ({
  onClose,
}) => {
  return (
    <Modal onClose={onClose}>
      <div className={styles.modalWrapper}>
        <ModalHeader onClose={onClose}>Navigation options</ModalHeader>
        <div className={styles.modalBody}>
          <table className={styles.navigationTable}>
            <tbody>
              <tr>
                <th colSpan={2}>Mouse with scroll wheel</th>
              </tr>
              <tr>
                <td>Select whiteboard shapes</td>
                <td>Left click</td>
              </tr>
              <tr>
                <td>Zoom in/out</td>
                <td>Scroll wheel</td>
              </tr>
              <tr>
                <td>Move around the whiteboard</td>
                <td>
                  Right click and drag
                  <br />
                  Hold space and drag
                </td>
              </tr>
              <tr>
                <td>Scroll horizontally</td>
                <td>Shift + scroll wheel</td>
              </tr>
              <tr>
                <th colSpan={2}>Trackpad</th>
              </tr>
              <tr>
                <td>Select whiteboard shapes</td>
                <td>Click</td>
              </tr>
              <tr>
                <td>Zoom in/out</td>
                <td>
                  Pinch gesture
                  <br />
                  {isMac && 'Hold ⌘  and scroll'}
                  {!isMac && 'Hold Ctrl and scroll'}
                  <br />
                </td>
              </tr>
              <tr>
                <td>Move around the whiteboard</td>
                <td>
                  Slide two fingers
                  <br />
                  Hold space and drag
                  <br />
                  Right click and drag
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
};

export default ApplicationView(PointerInputHelpModal);
